<script lang="ts">
	import Logo from '../components/logo.svelte';
	import Toolbar from '../components/toolbar.svelte';
	import type { PageData } from './$types';

	import '../../node_modules/open-props/normalize.min.css';
	import { browser, dev } from '$app/environment';
	import { wpBaseURL, wpDomain } from '$lib/api';

	export let data: PageData;

	const rows = [
		{
			title: 'Kategóriák',
			links: data.categories
				.filter((c) => c.name !== 'Uncategorized')
				.sort((a, b) => b.count - a.count)
				.slice(1, 5)
				.map((cat) => ({
					text: cat.name,
					href: `/category/${cat.id}`
				}))
		},
		{
			title: 'Szerkesztőség',
			links: [
				{ text: 'Rólunk', href: '/x/rolunk' },
				{ text: 'Cikk beküldése', href: `${wpDomain}/cikk-bekuldese/` },
				{ text: 'Belépés', href: `${wpDomain}/log-in/` },
				{ text: 'Regisztráció', href: `${wpDomain}/register/` }
			]
		}
	].filter((row) => row.links.length > 0);

	if (browser && !dev) import('./sentry');
</script>

<Toolbar />
<slot />

<footer>
	<section>
		<Logo size={4} />
		<ul>
			<li class="ig-link">
				<a href="https://www.instagram.com/tfgdiakok/" target="_blank" rel="noopener noreferrer">
					<svg
						aria-hidden="true"
						role="img"
						width="1em"
						height="1em"
						preserveAspectRatio="xMidYMid meet"
						viewBox="0 0 24 24"
					>
						<defs>
							<linearGradient
								id="ig-gradient"
								gradientUnits="userSpaceOnUse"
								x1="0%"
								y1="0%"
								x2="100%"
								y2="0%"
								gradientTransform="rotate(75)"
							>
								<stop offset="0%" stop-color="hsl(259deg 95% 60%)" />
								<stop offset="50%" stop-color="hsl(339deg 100% 55%)" />
								<stop offset="100%" stop-color="hsl(50deg 100% 50%)" />
							</linearGradient>
						</defs>

						<path
							stroke-width="0"
							d="M12 0C8.74 0 8.333.015 7.053.072C5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053C.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913a5.885 5.885 0 0 0 1.384 2.126A5.868 5.868 0 0 0 4.14 23.37c.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558a5.898 5.898 0 0 0 2.126-1.384a5.86 5.86 0 0 0 1.384-2.126c.296-.765.499-1.636.558-2.913c.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913a5.89 5.89 0 0 0-1.384-2.126A5.847 5.847 0 0 0 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071c1.17.055 1.805.249 2.227.415c.562.217.96.477 1.382.896c.419.42.679.819.896 1.381c.164.422.36 1.057.413 2.227c.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227a3.81 3.81 0 0 1-.899 1.382a3.744 3.744 0 0 1-1.38.896c-.42.164-1.065.36-2.235.413c-1.274.057-1.649.07-4.859.07c-3.211 0-3.586-.015-4.859-.074c-1.171-.061-1.816-.256-2.236-.421a3.716 3.716 0 0 1-1.379-.899a3.644 3.644 0 0 1-.9-1.38c-.165-.42-.359-1.065-.42-2.235c-.045-1.26-.061-1.649-.061-4.844c0-3.196.016-3.586.061-4.861c.061-1.17.255-1.814.42-2.234c.21-.57.479-.96.9-1.381c.419-.419.81-.689 1.379-.898c.42-.166 1.051-.361 2.221-.421c1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 1 0 0 12.324a6.162 6.162 0 1 0 0-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 0 1-2.88 0a1.44 1.44 0 0 1 2.88 0z"
						/></svg
					>
					<span> @tfgdiakok </span>
				</a>
			</li>
			<li>&copy; {new Date().getFullYear()}</li>
		</ul>
	</section>
	{#each rows as row}
		<section>
			<h2>{row.title}</h2>
			<ul>
				{#each row.links as link}
					<li>
						<a href={link.href}>{link.text}</a>
					</li>
				{/each}
			</ul>
		</section>
	{/each}
</footer>

<style lang="postcss">
	@import '../index.css';
	footer {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		padding: 1.5rem;
		background-color: var(--gray-8);
		--text-1: var(--gray-3);
		--text-2: var(--gray-3);
		margin-block-start: 2em;

		& h2 {
			font-size: 2em;
			max-inline-size: unset;
		}

		& section:not(:first-child) {
			padding-top: 1em;
		}

		& section:first-child {
			display: grid;
			grid-template-rows: 1fr auto;
		}

		& ul {
			list-style: none;
			padding: 0;
			margin: 0;
		}

		& li {
			padding: 0;
		}

		& li a svg,
		& li span {
			vertical-align: middle;
			display: inline-block;
		}

		& path {
			will-change: fill;
			transition: all 0.3s ease;
			fill: currentColor;
		}

		& a:hover path {
			fill: url(#ig-gradient);
		}
	}

	.ig-link a {
		text-decoration: none;
	}

	@media (max-width: 45em) {
		footer {
			grid-template-columns: 1fr;
			text-align: center;
			& li {
				margin: 0;
				max-inline-size: revert;
			}
			& section:first-child {
				grid-row: 3;
			}
		}
	}
	footer,
	footer a {
		color: var(--gray-3);
	}
	::global(*) {
		-webkit-tap-highlight-color: transparent;
	}
</style>
